import React from "react";
import { Action, Delete } from "../../../shared";
import EditPersonaAudience from "./edit";
import PersonaAudienceView from "./view";
import { DELETE_PERSONA } from "./query";
import { type Props } from "./types";

function action({ data }: Props) {
    const personaAction = [
        {
            id: "viewPersona",
            name: "View Persona",
            content: <PersonaAudienceView data={data} />,
        },
        {
            id: "editPersona",
            name: "Edit Persona",
            content: <EditPersonaAudience persona={data} title={"Edit Persona"} />,
        },
        {
            id: `deletePersona${data.id}`,
            name: "Delete Persona",
            content: <Delete title="Persona" id={data.id.toString()} query={DELETE_PERSONA} />,
        },
    ];
    return <Action actionTabItems={personaAction} />;
}

export default action;
